import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';

import useParent from '../../../hooks/useParent';
import UnderConstruction from '../UnderContructionWrapper';

const Teachers = () => {
  const { currentChild } = useParent();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentChild) {
      navigate('/parent/settings', { state: { label: 'Account Information' } });
    }
  }, [currentChild, navigate]);
  return (
    <UnderConstruction
      icon={<Users size={48} />}
      title="Teachers Page Under Construction"
      description="We’re building tools to help you connect with your child’s teachers—stay tuned!"
    />
  );
};

export default Teachers;
